<app-back-to-system-overview relativeUrl="../"></app-back-to-system-overview>
<sh-card>
  <api-call-gate [apiCall]="serviceTicketsService.getTickets">
    <ng-template #error let-error>
      <sh-text size="body-1" color="secondary">
        No tickets found
        <br />
        <b>Error {{ error.status }}</b
        ><br />
        {{ error.text }}
      </sh-text>
    </ng-template>
    <ng-template #lastSuccessfulData>
      <ng-container
        *ngTemplateOutlet="
          tickets;
          context: { $implicit: processedTickets$ | async }
        "
      ></ng-container>
    </ng-template>
  </api-call-gate>
</sh-card>

<ng-template #tickets let-tickets>
  <div style="display: flex; flex-direction: row; margin-bottom: 1rem">
    <sh-text size="header-2" color="primary">
      {{ 'label.serviceTickets' | translate }}
    </sh-text>
    <sh-text size="body-1" color="secondary" style="text-align: right">
      <span class="ticket-count-row">
        <b>{{ processedTicketsCount$ | async }}</b>
        <span hide-phone>displaying</span> /
        <b>{{ totalTicketsCount$ | async }}</b>
        <span hide-phone>available</span>
      </span>
    </sh-text>
  </div>
  <div class="menu">
    <ng-container *ngTemplateOutlet="filtersDesktop"></ng-container>
  </div>

  <div class="container">
    <ng-container *ngIf="(totalTicketsCount$ | async) === 0">
      <sh-empty-state
        style="margin: auto"
        icon="search"
        label="No records found"
      ></sh-empty-state>
    </ng-container>

    <ng-container *ngIf="tickets.length > 0; else nomatches">
      <ng-container
        *ngTemplateOutlet="
          (screenLayoutService.desktopAny$ | async)
            ? ticketsDesktop
            : ticketsMobile;
          context: { $implicit: tickets }
        "
      ></ng-container>
    </ng-container>
    <ng-template #nomatches> No tickets matched your criteria </ng-template>
  </div>
</ng-template>

<!-- ticket filters: desktop -->
<!-- responsive property on sh-date-picker is the it('should filter tickets') to fail -->
<ng-template #filtersDesktop>
  <sh-datepicker
    *ngIf="dateRangeValid"
    [months]="screenLayoutService.datePickerMonths$ | async"
    responsive
    no-clear
    class="filterFiled"
    label="Date Range"
    [betterValue]="(filters$ | async)?.daterange"
    (betterCleared)="clearAndResetDateRange()"
    (betterChanged)="onDateRangeChanged($event.detail)"
    [min]="(dateBoundsForShui$ | async)?.min"
    [max]="(dateBoundsForShui$ | async)?.max"
    range
  ></sh-datepicker>
  <sh-dropdown
    size="body-2"
    class="filterFiled"
    label="Operational State"
    [value]="(filters$ | async)?.operationalState"
    (value-changed)="onOpertationalStateChanged($event.target.value)"
  >
    <sh-menu-item
      *ngFor="let status of operationalStates$ | async"
      label="{{ status }}"
    ></sh-menu-item>
  </sh-dropdown>
  <sh-search
    size="body-2"
    class="filterFiled"
    label="Search Term"
    [value]="(filters$ | async)?.searchString"
    (value-changed)="onSearchString($event.target.value)"
  ></sh-search>
  <sh-icon
    style="margin: 7px; cursor: pointer"
    icon="reset"
    id="refresh"
    (click)="resetFilters()"
  ></sh-icon>
  <sh-text size="header-2" class="reset-filters" color="secondary"
    >Reset Filters</sh-text
  >
</ng-template>

<!-- tickets: desktop -->
<ng-template #ticketsDesktop let-tickets>
  <sh-table>
    <sh-table-row slot="header">
      <sh-table-head unsortable columns="2"></sh-table-head>
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'creationDate',
            $event.target.hasAttribute('sort-descending')
          )
        "
        >{{ 'label.creationDate' | translate }}</sh-table-head
      >
      <sh-table-head
        columns="6"
        (toggle)="
          onChangeSort(
            'ticketNumber',
            $event.target.hasAttribute('sort-descending')
          )
        "
        ><span>{{ 'label.ticketNumber' | translate }}</span>
      </sh-table-head>
      <sh-table-head
        columns="16"
        (toggle)="
          onChangeSort(
            'description',
            $event.target.hasAttribute('sort-descending')
          )
        "
        >{{ 'label.description' | translate }}</sh-table-head
      >
      <sh-table-head
        columns="8"
        (toggle)="
          onChangeSort(
            'operationalState',
            $event.target.hasAttribute('sort-descending')
          )
        "
      >
        {{ 'label.Ticketstatus' | translate }}
      </sh-table-head>
    </sh-table-row>
    <sh-table-row *ngFor="let ticket of tickets">
      <sh-table-cell
        style="height: auto"
        class="ticket-indicator ticket"
        [attr.color]="ticket.statusColor"
        columns="2"
      >
        <sh-badge
          *ngIf="ticket.status === 'Closed'"
          style="margin-top: 7px"
          label="{{ ticket.status }}"
        ></sh-badge>
      </sh-table-cell>
      <sh-table-cell columns="6">
        {{ ticket.creationDate | localizedDate }}
      </sh-table-cell>
      <sh-table-cell columns="6" class="ticket">
        {{ ticket.ticketNumber }}
        <sh-icon
          id="copyToClipboard"
          style="cursor: pointer; margin-top: 5px"
          (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
          icon="copy-results-to-clipboard"
          aria-label="Copy results to clipboard"
          button
          size="s"
        ></sh-icon>
        <sh-tooltip
          label="Copy to Clipboard"
          target="copyToClipboard"
          placement="top"
          variation="short"
        >
        </sh-tooltip>
      </sh-table-cell>
      <sh-table-cell columns="16">
        <sh-text id="description" #description class="linebreak">
          {{ ticket.description }}</sh-text
        >
        <ng-container *ngIf="isOverflowing(description)">
          <sh-tooltip
            label="{{ ticket.description }}"
            target="description"
            placement="top"
            variation="short"
          ></sh-tooltip>
        </ng-container>
      </sh-table-cell>
      <sh-table-cell columns="8">
        {{ ticket.operationalState ? ticket.operationalState : 'Unknown' }}
      </sh-table-cell>
    </sh-table-row>
  </sh-table>
</ng-template>

<!-- tickets: phone -->
<ng-template #ticketsMobile let-tickets>
  <div class="tickets-mobile">
    <div
      class="ticket"
      *ngFor="let ticket of tickets"
      [attr.color]="ticket.statusColor"
    >
      <div class="item">
        <sh-text size="body-2" color="secondary">{{
          'label.creationDate' | translate
        }}</sh-text>
        <span>{{ ticket.creationDate | localizedDate }}</span>
        <sh-badge
          *ngIf="ticket.status === 'Closed'"
          style="margin-top: 7px"
          label="{{ ticket.status }}"
        ></sh-badge>
      </div>
      <div class="item">
        <sh-text size="body-2" color="secondary">{{
          'label.ticketNumber' | translate
        }}</sh-text>
        <span style="display: flex; white-space: nowrap"
          >{{ ticket.ticketNumber }}

          <sh-icon
            id="copyToClipboard"
            style="
              cursor: pointer;
              align-items: baseline;
              margin-top: -0.25rem;
              margin-left: 0.5rem;
              display: inline;
            "
            (click)="clipboard.copyToClipboard(ticket.ticketNumber)"
            icon="copy-results-to-clipboard"
            aria-label="Copy results to clipboard"
            button
            size="s"
          ></sh-icon>
        </span>
      </div>
      <div class="item" style="width: 100%">
        <sh-text size="body-2" color="secondary">{{
          'label.description' | translate
        }}</sh-text>
        <span>{{ ticket.description }}</span>
      </div>
      <div class="item">
        <sh-text size="body-2" color="secondary">{{
          'label.TicketstatusFN' | translate
        }}</sh-text>
        <span>{{
          ticket.operationalState ? ticket.operationalState : 'Unknown'
        }}</span>
      </div>
    </div>
  </div>
</ng-template>
